module.exports = __webpack_public_path__ + "media/assets/images/tour/7_Tour_4-612485df1ba13dc7c5644800438d7663.png";